import React from 'react'
import { Form } from 'antd'
import classNames from 'classnames'

import styles from './styles.module.scss'

import type { LntFormGroupProps } from './types'

export const LntFormGroup: React.FC<LntFormGroupProps> = ({ className: outerClassName, children, ...props }) => {
  const className: string = classNames(styles.lntFormGroup, outerClassName)

  return (
    <Form.Item
      { ...props }
      className={ className }
    >
      { children }
    </Form.Item>
  )
}
